import React from "react";
import AsyncAutocomplete from "../../asyncAutocomplete";

export default function SearchFilterAsyncAutoComplete({ filterOptions, searchType, onSearchValueDropDownSelect, onSearchValueChange, searchValue }) {
    const suggestions = filterOptions[searchType.key];

    const onSelect = (suggestion) => {
        onSearchValueDropDownSelect(suggestion);
    };

    const onChange = (value) => {
        onSearchValueChange(value);
    };

    return (
        <AsyncAutocomplete
            suggestions={suggestions}
            filterSuggestions={true}
            onSelect={onSelect}
            inputValue={searchValue}
            onChange={(value) => onChange(value)}
            filterSuggestions={true}
        />
    );
}
